import type { SortDirection } from "ag-grid-community"

export enum ProductTableType {
  HiddenSKUs = "hiddenSKUs",
  Default = "default",
  NPI = "npi",
  Settings = "settings",
  Collection = "collection",
  PurchasePlan = "purchasePlan",
  SeasonalBuys = "seasonalBuys",
  ReplenishmentSuggestions = "replenishmentSuggestions",
  ProductManagement = "productManagement",
  NoosDemandPlan = "noosDemandPlan",
  ForecastUpdates = "forecastUpdates",
  None = "none",
  NoosOverview = "noosOverview",
  NoosAvailability = "noosAvailability",
  /** NOOS Greige and Capacity Planning tabs. */
  NoosPlanning = "noosPlanning",
  Demand2 = "demand2",
}

// ghostTown has no entries in actionDisabledTooltips: every command-bar action stays
// enabled so CS can rescue stranded variants (collect, activate, phase out, hide).
export type NpiTabContext = "inbox" | "active" | "hidden" | "phasedOut" | "phasingOut" | "ghostTown"

export const defaultSortingOrder: SortDirection[] = ["desc", "asc", null]
